import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M17.1875 8.75074V16.2507C17.1875 16.6651 17.0229 17.0626 16.7299 17.3556C16.4368 17.6486 16.0394 17.8132 15.625 17.8132H4.375C3.9606 17.8132 3.56317 17.6486 3.27015 17.3556C2.97712 17.0626 2.8125 16.6651 2.8125 16.2507V8.75074C2.8125 8.33634 2.97712 7.93891 3.27015 7.64588C3.56317 7.35286 3.9606 7.18824 4.375 7.18824H5.9375C6.18614 7.18824 6.4246 7.28701 6.60041 7.46283C6.77623 7.63864 6.875 7.8771 6.875 8.12574C6.875 8.37438 6.77623 8.61284 6.60041 8.78865C6.4246 8.96447 6.18614 9.06324 5.9375 9.06324H4.6875V15.9382H15.3125V9.06324H14.0625C13.8139 9.06324 13.5754 8.96447 13.3996 8.78865C13.2238 8.61284 13.125 8.37438 13.125 8.12574C13.125 7.8771 13.2238 7.63864 13.3996 7.46283C13.5754 7.28701 13.8139 7.18824 14.0625 7.18824H15.625C16.0394 7.18824 16.4368 7.35286 16.7299 7.64588C17.0229 7.93891 17.1875 8.33634 17.1875 8.75074ZM7.53828 5.66402L9.0625 4.14136V10.6257C9.0625 10.8744 9.16127 11.1128 9.33709 11.2887C9.5129 11.4645 9.75136 11.5632 10 11.5632C10.2486 11.5632 10.4871 11.4645 10.6629 11.2887C10.8387 11.1128 10.9375 10.8744 10.9375 10.6257V4.14136L12.4617 5.66636C12.5489 5.75357 12.6525 5.82275 12.7664 5.86994C12.8803 5.91714 13.0025 5.94143 13.1258 5.94143C13.2491 5.94143 13.3712 5.91714 13.4852 5.86994C13.5991 5.82275 13.7026 5.75357 13.7898 5.66636C13.877 5.57916 13.9462 5.47563 13.9934 5.36169C14.0406 5.24775 14.0649 5.12563 14.0649 5.0023C14.0649 4.87897 14.0406 4.75685 13.9934 4.64291C13.9462 4.52897 13.877 4.42545 13.7898 4.33824L10.6648 1.21324C10.5777 1.12584 10.4743 1.05649 10.3603 1.00917C10.2463 0.961857 10.1242 0.9375 10.0008 0.9375C9.87739 0.9375 9.75522 0.961857 9.64126 1.00917C9.52731 1.05649 9.42382 1.12584 9.33672 1.21324L6.21172 4.33824C6.12451 4.42545 6.05534 4.52897 6.00814 4.64291C5.96095 4.75685 5.93665 4.87897 5.93665 5.0023C5.93665 5.25137 6.0356 5.49024 6.21172 5.66636C6.38784 5.84248 6.62671 5.94143 6.87578 5.94143C7.12485 5.94143 7.36372 5.84248 7.53984 5.66636L7.53828 5.66402Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconShare'

export const IconShare = memo(themed(Icon))
